import Vue from 'vue'
import App from './App.vue'
import VueVideoPlayer from 'vue-video-player'
import api from '@/api'
import '@/assets/svg-icons'
import IconSvg from '@/components/icon-svg'
import 'video.js/dist/video-js.css'

import { Button, Form, Field, Tab, Tabs, Sticky , Lazyload } from 'vant'


Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.use(VueVideoPlayer)
Vue.component('icon-svg', IconSvg)

Vue.use(Button).use(Form).use(Field).use(Tab).use(Tabs).use(Sticky).use(Lazyload)

new Vue({
  render: h => h(App)
}).$mount('#app')
